import { z } from 'zod'
import { toUidFromSchema } from 'src/util/src/uid'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { NameSchema } from '../../Generic/models/Name'
import { NotesSchema } from '../../Generic/models/Notes'
import { SocialNetworkSchema, SocialNetworkUidSchema } from './SocialNetwork'
import { UrlPatternSchema } from '../../Generic/models/UrlPattern'

export const SocialChannelTypeSchema = z.object({
  name: NameSchema,
  network: SocialNetworkSchema,
  followUrlPattern: UrlPatternSchema,
  notes: NotesSchema,
})

export const SocialChannelTypesSchema = z.array(SocialChannelTypeSchema)
  .superRefine(getDuplicatesRefinement('SocialChannelType', getSocialChannelTypeUid))

export const SocialChannelTypeUidSchema = z.object({
  name: SocialChannelTypeSchema.shape.name,
  network: SocialNetworkUidSchema,
})

export type SocialChannelType = z.infer<typeof SocialChannelTypeSchema>

export type SocialChannelTypeUid = z.infer<typeof SocialChannelTypeUidSchema>

export function validateSocialChannelType(type: SocialChannelType): SocialChannelType {
  return SocialChannelTypeSchema.parse(type)
}

export function validateSocialChannelTypes(types: SocialChannelType[]): SocialChannelType[] {
  return SocialChannelTypesSchema.parse(types)
}

export function getSocialChannelTypeUid(typeUid: SocialChannelTypeUid) {
  return toUidFromSchema(typeUid, SocialChannelTypeUidSchema)
}
